// Geometry pins contain no catalogue defaults, URLs or product knowledge.
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/;
const HASH = /^[0-9a-f]{64}$/;
const KEYS = ['contract', 'contractVersion', 'assetObjectId', 'assetId', 'revisionId', 'variantId', 'packageDigest', 'variantDigest', 'sourceSha256'];
const check = (ok, message) => { if (!ok) throw new TypeError(`Asset reference: ${message}`); };

export function assetPackageLocator(value) {
  check(value && Number.isSafeInteger(value.assetObjectId) && value.assetObjectId > 0, 'invalid asset object');
  check(typeof value.revisionId === 'string' && UUID.test(value.revisionId), 'explicit revision required');
  const variantId = value.variantId ?? 'default';
  check(typeof variantId === 'string' && (variantId === 'default' || /^v-[0-9a-f]{64}$/.test(variantId)), 'invalid variant');
  return Object.freeze({ assetObjectId: value.assetObjectId, revisionId: value.revisionId, variantId });
}

/** Strict detached JSON value suitable for persistence; never resolves "latest". */
export function createAssetReference(value) {
  check(value && typeof value === 'object' && !Array.isArray(value), 'object required');
  const descriptors = Object.getOwnPropertyDescriptors(value);
  check(Reflect.ownKeys(descriptors).length === KEYS.length
    && KEYS.every(key => descriptors[key]?.enumerable && Object.hasOwn(descriptors[key], 'value')), 'unexpected or accessor fields');
  const copy = Object.fromEntries(KEYS.map(key => [key, descriptors[key].value]));
  check(copy.contract === 'ks.asset-reference' && copy.contractVersion === 1, 'unsupported contract');
  assetPackageLocator(copy);
  check(typeof copy.variantId === 'string', 'explicit variant required');
  check(typeof copy.assetId === 'string' && copy.assetId.length > 0 && copy.assetId.length <= 256
    && copy.assetId.isWellFormed() && [...copy.assetId].every(char => char.charCodeAt(0) >= 32), 'invalid asset identity');
  check(['packageDigest', 'variantDigest', 'sourceSha256'].every(key => typeof copy[key] === 'string' && HASH.test(copy[key])), 'invalid digest');
  return Object.freeze(copy);
}

export function assetReferenceKey(value) {
  return JSON.stringify(createAssetReference(value));
}
